import React from 'react';
import SubServices from '../common/sub-services';
const OdooDevelopmentServies = () => {
    return (
        <div className="section-py section-pt bg-grey dark:bg-black for_ribbon">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-8 lg:col-start-3 pb-50">
                        <p
                            className="text-primary mb-0 fs-lg fw-700"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            Odoo Development Services
                        </p>
                        <h2 data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Tailored Solutions for Your Business Growth
                        </h2>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-3 lg:grid-cols-2 md:grid-cols-2">
                    <SubServices
                        path={'/img/technology/ic-odoo-customization.svg'}
                        height={64}
                        width={64}
                        alt="customization"
                        title="customization"
                        serviceName="Custom Odoo Development"
                        serviceDescription="At Moweb, we believe in the power of tailored solutions. Do you require specific customizations, and to what degree? We don't assume; we listen intently. Our dedicated team invests time to comprehend your unique business processes, challenges, and aspirations. By diving deep into your operations, we pinpoint the precise customizations your Odoo ERP demands, ensuring perfect alignment with your objectives. Our aim is to elevate your productivity and efficiency, crafting a solution that resonates uniquely with your business needs."
                    />
                    <SubServices
                        path={'/img/technology/ic-odoo-implementation.svg'}
                        height={64}
                        width={64}
                        alt="implementation"
                        title="implementation"
                        serviceName="Efficient Odoo Implementation"
                        serviceDescription="Navigating through a new system can be overwhelming. That's why we stand by you throughout the journey. Our Odoo implementation services are crafted to feel like a strategic partnership. We start by understanding your current setup and identifying areas for enhancement. From data migration to user training, our team manages every aspect, guaranteeing a seamless transition. With Moweb, you're not just receiving a service; you're gaining a dedicated partner committed to streamlining and optimizing your business operations."
                    />
                    <SubServices
                        path={'/img/technology/ic-odoo-integration.svg'}
                        height={64}
                        width={64}
                        alt="integration"
                        title="integration"
                        serviceName="Seamless Odoo Integration"
                        serviceDescription="Your business ecosystem is intricate, and we're here to ensure seamless harmony. Our Odoo integration services focus on creating a unified business environment. We meticulously analyze your existing software landscape, identifying optimal integration opportunities. Whether it's CRM, eCommerce, or accounting systems, we ensure seamless synchronization, fostering collaboration and driving growth. At Moweb, we prioritize making your operations as interconnected and smooth as possible."
                    />
                    <SubServices
                        path={'/img/technology/ic-odoo-migration.svg'}
                        height={64}
                        width={64}
                        alt="migration"
                        title="migration"
                        serviceName="Accelerated Odoo Migration"
                        serviceDescription="Change can be daunting, but we make it hassle-free. Our Odoo migration services ensure a smooth, stress-free transition. We begin with a comprehensive assessment, leaving no detail unchecked. Our experts manage the entire process, from data integrity checks to post-migration support. We understand the significance of minimal disruption, and our team works diligently to seamlessly integrate your upgraded technologies. With Moweb, your business remains future-ready."
                    />
                    <SubServices
                        path={'/img/technology/ic-odoo-support.svg'}
                        height={64}
                        width={64}
                        alt="support"
                        title="support"
                        serviceName="Consistent Odoo Support"
                        serviceDescription="Support is more than just problem-solving—it's about being there whenever you need us. Our ensured Odoo support services prioritize your peace of mind. We offer proactive monitoring, regular maintenance, and immediate troubleshooting, ensuring uninterrupted operations. Our dedicated support team is always at your service, allowing you to focus on your core business. At Moweb, we're committed to being your trusted partner, round the clock."
                    />
                    <SubServices
                        path={'/img/technology/ic-odoo-consulting.svg'}
                        height={64}
                        width={64}
                        alt="consulting"
                        title="consulting"
                        serviceName="Strategic Odoo Consultancy"
                        serviceDescription="Navigating Odoo complexities can be overwhelming. That's where our consultancy services come in, providing clear, strategic guidance. We start by understanding your business goals and challenges, tailoring Odoo solutions that drive efficiency and growth. Our consultants are more than advisors; they're partners in your success. We offer transparent, actionable insights that foster sustainable growth. With Moweb, you're never alone on your journey to success."
                    />
                </div>
            </div>
        </div>
    );
};

export default OdooDevelopmentServies;
